// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".change-password-form[data-v-62385802] {\n  padding: 20px 0;\n}\n.g-dialog__form-item[data-v-62385802] {\n  margin-bottom: 20px;\n}\n.g-dialog__form-item[data-v-62385802]:last-child {\n  margin-bottom: 0;\n}\n.change-password-actions[data-v-62385802] {\n  margin-top: 30px;\n  text-align: center;\n  font-size: 16px;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
